import { Card, Col, Form, Row } from 'antd';
import {
  ButtonBack,
  ButtonSubmit
} from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useOrgRepo from 'services/repo/useOrgRepo';
import useWorkingcalendarRepo from 'services/repo/useWorkingcalendarRepo';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import {
  dismissToast,
  errorToast,
  loadingToastId,
  successToast
} from 'utils/Toast';
import {
  CustomFormItemInteger,
  CustomFormItemSelectDropdown,
  CustomFormItemSwitch,
  CustomFormItemIntegerLabelPercentage
} from 'components/Common/CustomFormItem';

const currentYear = new Date().getFullYear();
const INIT_WORKCALENDAR = {
  wcId: null,
  orgId: null,
  wcYear: currentYear,
  wcDayTotal: null,
  wcAnnualLeave: null,
  wcNationalHoliday: null,
  wcWeekend: null,
  wcWorkDayTotal: null,
  wcWorkHourTotal: null,
  wcEfficiencyFactor: null,
  wcEffectiveHour: null,
  status: true
};

export default function ManageWorkingCalendar() {
  const { wcId } = useParams();
  useTopbarTitleHooks(`${wcId ? "Edit" : "Create"} Work Calendar Setting`);
  const isEditMode = Boolean(wcId);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { getOrgList } = useOrgRepo(false);
  const { isLoading: isLoadingSave,
    createWorkCal,
    updateWorkCal,
    getWorkCalById
  } = useWorkingcalendarRepo(false);

  const [orgOptions, setOrgOptions] = useState([]);
  const [efficiencyFactor, setEfficiencyFactor] = useState(0);
  const [orgListReady, setOrgListReady] = useState(false);


  const isLoadingPrivilege = useRef(true);

  const yearOptions = Array.from({ length: 6 }, (_, i) => currentYear + i);

  const fetchOrgList = async () => {
    const res = await getOrgList({
      pageNumber: 1,
      pageSize: 0,
      orderBy: 'orgId',
      isAscending: true,
      filter: {
        orgId: null,
        orgName: '',
        status: 'true'
      }
    });
    if (res?.status === 200 && res?.detail === 'OK') {
      const orgOptions = res.data.content.map((item) => ({
        label: item.orgName,
        value: item.orgId,
        efficiencyFactor: item.orgEfficiencyFactor
      }));

      setOrgOptions(orgOptions);
      setOrgListReady(true); // ✅ biar fetchDataById bisa jalan

      // ✅ Auto-select jika hanya ada 1 opsi
      if (orgOptions.length === 1) {
        const selectedOrg = orgOptions[0];
        // Set efficiency factor
        const ef = Number(selectedOrg.efficiencyFactor || 0);
        setEfficiencyFactor(ef);
        form.setFieldsValue({ wcEfficiencyFactor: ef });

        // Hitung langsung jika field waktu kerja sudah terisi
        const values = form.getFieldsValue();
        const totalWorkHours = Number(values.wcWorkHourTotal || 0);
        if (totalWorkHours > 0 && ef > 0) {
          const effectiveHours = (totalWorkHours * ef) / 100;
          form.setFieldsValue({ wcEffectiveHour: effectiveHours });
        }
        // const selectedOrg = orgOptions[0];
        // setDataField((prev) => ({ ...prev, orgId: selectedOrg.value }));
        // form.setFieldsValue({ orgNameOption: selectedOrg.value });
        form.setFieldsValue({ orgId: selectedOrg.value });
      }
      // const mapped = res.data.content.map(item => ({
      //   label: item.orgName,
      //   value: item.orgId,
      //   efficiencyFactor: item.orgEfficiencyFactor
      // }));
      // setOrgOptions(mapped);
      // setOrgListReady(true); // <-- Tambahkan ini
    }
  };

  const fetchDataById = async () => {
    if (!wcId) return;
    const res = await getWorkCalById({ wcId });
    if (res?.status === 200 && res?.detail === 'OK') {
      const data = res.data;
      //setEfficiencyFactor(Number(data.wcEfficiencyFactor));

      form.setFieldsValue({
        ...data,
        status: data.status === 'true'
      });

      const orgId = data?.orgId;

      if (orgId) {
        const selectedOrg = orgOptions.find(item => item.value === orgId);
        if (selectedOrg) {

          const ef = Number(selectedOrg.efficiencyFactor || 0);
          setEfficiencyFactor(ef);
          form.setFieldsValue({
            wcEfficiencyFactor: ef,
          });

          const totalWorkHours = Number(data.wcWorkHourTotal || 0);
          if (totalWorkHours > 0 && ef > 0) {
            const effectiveHours = (totalWorkHours * ef) / 100;
            form.setFieldsValue({ wcEffectiveHour: effectiveHours });
          }
        }
      } else {
        alert('orgId masih kosong = ' + orgId)
      }


      // const selectedOrg = orgOptions.find(item => item.value === data.orgId);

      // if (selectedOrg) {
      //   const ef = Number(selectedOrg.efficiencyFactor || 0);
      //   setEfficiencyFactor(ef);
      //   form.setFieldsValue({ wcEfficiencyFactor: ef });

      //   // Hitung ulang jumlah jam kerja efektif
      //   const totalWorkHours = Number(data.wcWorkHourTotal || 0);
      //   if (totalWorkHours > 0 && ef > 0) {
      //     const effectiveHours = (totalWorkHours * ef) / 100;
      //     form.setFieldsValue({ wcEffectiveHour: effectiveHours });
      //   }
      // }
      //calculateFields();
      // Hitung ulang jam kerja efektif jika semua nilai tersedia
      // const workHours = Number(data.wcWorkHourTotal || 0);
      // const ef = Number(data.wcEfficiencyFactor || 0);
      // if (workHours > 0 && ef > 0) {
      //   const effectiveHours = (workHours * ef) / 100;
      //   form.setFieldsValue({ wcEffectiveHour: effectiveHours });
      // }
    }
  };

  const handleOrgChange = (value) => {
    const selected = orgOptions.find(item => item.value === value);

    if (selected) {
      const ef = Number(selected.efficiencyFactor);
      setEfficiencyFactor(ef);
      form.setFieldsValue({ wcEfficiencyFactor: ef });

      const values = form.getFieldsValue();
      const totalWorkHours = Number(values.wcWorkHourTotal || 0);

      // Hanya hitung ulang jika totalWorkHours dan ef tersedia
      if (totalWorkHours > 0 && ef > 0) {
        const effectiveHours = (totalWorkHours * ef) / 100;
        form.setFieldsValue({ wcEffectiveHour: effectiveHours });
      }
    } else {
      // Clear field saat orgId dihapus
      setEfficiencyFactor(undefined);
      form.setFieldsValue({
        wcEfficiencyFactor: undefined,
        wcEffectiveHour: undefined
      });
    }
  };

  const calculateFields = () => {
    const values = form.getFieldsValue();

    const totalDays = Number(values.wcDayTotal || 0);
    const annualLeave = Number(values.wcAnnualLeave || 0);
    const nationalHoliday = Number(values.wcNationalHoliday || 0);
    const weekend = Number(values.wcWeekend || 0);

    const workDays = totalDays - annualLeave - nationalHoliday - weekend;
    const totalWorkHours = workDays * 8;
    // const effectiveHours = (totalWorkHours * efficiencyFactor) / 100;
    const effectiveHours =
      efficiencyFactor && Number(efficiencyFactor) > 0
        ? (totalWorkHours * efficiencyFactor) / 100
        : undefined;

    form.setFieldsValue({
      wcWorkDayTotal: workDays,
      wcWorkHourTotal: totalWorkHours,
      wcEffectiveHour: effectiveHours
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    CustomAlert.confirm({
      title: "Submit Work Calendar Setting!",
      description: "Are you sure you want to submit this data?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      type: "primary",
      onConfirmButton: () => handleSubmit()
    });
  };


  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const payload = {
        ...values,
        wcEfficiencyFactor: efficiencyFactor,
        status: String(values.status)
      };

      const key = 'saving_work_calendar';
      loadingToastId(Constant.message.savingData, key);

      const res = wcId
        ? await updateWorkCal({ ...payload, wcId })
        : await createWorkCal(payload);

      dismissToast(key);

      if (res?.status === 200 && res?.detail === 'OK') {
        successToast(Constant.message.saveDataSuccess);
        navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.masterData.WorkingCalendar.index);
      } else {
        errorToast(Constant.message.fail);
      }
    }).catch(() => errorToast(Constant.message.errorForm));
  };


  useEffect(() => {
    if (wcId && orgListReady) {
      fetchDataById(); // <--- Hanya jalan saat orgOptions sudah diisi
    }
  }, [wcId, orgListReady]); // <--- Perhatikan dependensinya


  useEffect(() => {
    fetchOrgList(); // <--- Load dulu list organisasi

    if (!wcId) {
      // Kalau mode CREATE, isi default form
      form.setFieldsValue(INIT_WORKCALENDAR);
      isLoadingPrivilege.current = false;
    }
  }, []);



  return (
    <Card>
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        labelAlign="left"
        onValuesChange={calculateFields}
      >
        <Row gutter={[16]}>
          <Col span={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="orgId"
              label="Nama Organisasi"
              showSearch
              // value={dataField.orgId}
              rules={[{ required: true }]}
              placeholder="Pilih Organisasi"
              options={orgOptions}
              onChange={handleOrgChange}
              disabled={isEditMode}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }}
            />
          </Col>

          <Col span={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="wcYear"
              label="Tahun Kalendar"
              rules={[{ required: true }]}
              placeholder="Pilih Tahun"
              options={yearOptions.map(y => ({ label: y, value: y }))}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }}
            />
          </Col>

          <Col span={24}>
            <CustomFormItemInteger nameFormItem="wcDayTotal" label="Jumlah hari per tahun" rules={[{ required: true }]} min={1} max={1000}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }} />
          </Col>

          <Col span={24}>
            <CustomFormItemInteger nameFormItem="wcAnnualLeave" label="Cuti Tahunan" rules={[{ required: true }]} min={0} labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }} />
          </Col>

          <Col span={24}>
            <CustomFormItemInteger nameFormItem="wcNationalHoliday" label="Jumlah Hari Libur Nasional"
              rules={[{ required: true }]} min={0}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }} />
          </Col>

          <Col span={24}>
            <CustomFormItemInteger nameFormItem="wcWeekend" label="Jumlah Hari Weekend" rules={[{ required: true }]} min={0}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }} />
          </Col>

          <Col span={24}>
            <CustomFormItemInteger nameFormItem="wcWorkDayTotal" label="Jumlah Hari Kerja" disabled rules={[{ required: true }]} min={0}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }} />
          </Col>

          <Col span={24}>
            <CustomFormItemInteger nameFormItem="wcWorkHourTotal" label="Total Jam Kerja Tahun" disabled labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }} />
          </Col>


          <Col span={24}>
            <CustomFormItemIntegerLabelPercentage
              nameFormItem="wcEfficiencyFactor"
              label="Efficiency Factor"
              disabled
              rules={[
                { required: true },
              ]}
              suffix="%"
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }}
            />
          </Col>

          <Col span={24}>
            <CustomFormItemInteger nameFormItem="wcEffectiveHour" label="Jumlah Jam Kerja Efektif" disabled labelCol={{ span: 5 }}
              wrapperCol={{ span: 8 }} />
          </Col>

          <Col span={24}>
            <CustomFormItemSwitch nameFormItem="status" label="Status" labelCol={{ span: 5 }}
              wrapperCol={{ span: 16 }} />
          </Col>

          <Col span={24} offset={6} style={{ marginTop: 16 }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <ButtonBack onClick={() => navigate(APP_ROUTE_PREFIX + '/' + RouteConstant.masterData.WorkingCalendar.index)} />
              <ButtonSubmit onClick={handleFormSubmit} loading={isLoadingSave} disabled={isLoadingSave} />
            </div>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}
